<template>
    <div class="ah-card shadow deposit-summary-card">
        <div class="title">{{ this.year }} 存款總覽</div>
        <el-row :gutter="20" style="margin-top: 20px">
            <el-col :sm="14">
                <div v-loading="isLoading" element-loading-background="rgba(255, 255, 255, 0.5)" element-loading-text="載入中" style="min-height: 270px">
                    <DepositSummaryLineChart
                        v-show="isShowLineChart"
                        ref="lineChart"
                        :monthlyData="monthlyData"
                        :year="year"
                        style="width: 90%; height: 265px; margin-bottom: 20px; margin-left: auto; margin-right: auto"
                    />
                    <DepositSummaryBarChart
                        v-show="!isShowLineChart"
                        ref="barChart"
                        :taiwanDepositTotal="taiwanDepositTotal"
                        :foreignDepositTotal="foreignDepositTotal"
                        :cashTotal="cashTotal"
                        :taiwanLoanTotal="taiwanLoanTotal"
                        :foreignLoanTotal="foreignLoanTotal"
                        style="width: 90%; height: 265px; margin-bottom: 20px; margin-left: auto; margin-right: auto"
                    />
                    <div style="text-align: center; margin-bottom: 30px">
                        <ahTextSwitch trueText="年度曲線" falseText="存借款比較" v-model="isShowLineChart" @change="updateCharts" />
                    </div>
                </div>
            </el-col>
            <el-col :sm="10">
                <div v-loading="isLoading" element-loading-background="rgba(255, 255, 255, 0.5)" element-loading-text="載入中" style="min-height: 270px">
                    <div class="deposit-summary-list-block" style="margin-top: 25px">
                        <div class="summary">
                            <div class="title">
                                合併總計 <span style="font-size: 9pt; font-weight: normal; margin-left: 12px; color: #aaa">{{ date }}</span>
                            </div>
                            <div class="number" v-if="!isLoading"><money :v="summaryTotal" /> <span class="cny">TWD</span></div>
                        </div>
                        <table class="ah-default-simple-table hover deposit-summary-list" cellspacing="0" cellpadding="0">
                            <!-- <thead>
                                <tr>
                                    <th></th>
                                    <th class="name">類型</th>
                                    <th class="amt">即時餘額</th>
                                    <th class="cny">幣別</th>
                                    <th class="per">佔存款%</th>
                                </tr>
                            </thead> -->
                            <tbody>
                                <tr>
                                    <td class="dot"><span class="circle" style="background: #019b01"></span></td>
                                    <td class="name">台幣存款</td>
                                    <td class="amt"><money :v="taiwanDepositTotal" /></td>
                                    <td class="cny">TWD</td>
                                    <td class="per">
                                        <el-tooltip content="佔總存款＋零用現金" placement="top">
                                            <span>{{ taiwanDepositPercent }}%</span>
                                        </el-tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="dot"><span class="circle" style="background: #20c120"></span></td>
                                    <td class="name">外幣存款 (約當台幣)</td>
                                    <td class="amt"><money :v="foreignDepositTotal" /></td>
                                    <td class="cny">TWD</td>
                                    <td class="per">
                                        <el-tooltip content="佔總存款＋零用現金" placement="top">
                                            <span>{{ foreignDepositPercent }}%</span>
                                        </el-tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="dot"><span class="circle" style="background: #80ea80"></span></td>
                                    <td class="name">零用現金</td>
                                    <td class="amt"><money :v="cashTotal" /></td>
                                    <td class="cny">TWD</td>
                                    <td class="per">
                                        <el-tooltip content="佔總存款＋零用現金" placement="top">
                                            <span>{{ cashPercent }}%</span>
                                        </el-tooltip>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="dot"><span class="circle" style="background: #ff6d00"></span></td>
                                    <td class="name">借款總額</td>
                                    <td class="amt"><money :v="loanTotal" abs /></td>
                                    <td class="cny">TWD</td>
                                    <td class="per"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="font-size: 10pt; color: #888; margin-top: 15px; text-align: right;">
                            <div>
                                <span>（尚有請款單-待確認付款 </span>
                                <money :v="toBeCredited" abs round /> 元未扣除 </span>
                                <ah-tip><PaymentStatusLabel :statusNum="2" /> 的請款單在"確認"後，才會從帳戶中扣除該筆金額。</ah-tip>
                                <span>）</span>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import ahTextSwitch from '@/components/ui/ahTextSwitch.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import DepositSummaryLineChart from './charts/DepositSummaryLineChart.vue';
import DepositSummaryBarChart from './charts/DepositSummaryBarChart.vue';

export default {
    components: {
        ahTextSwitch,
        PaymentStatusLabel,
        DepositSummaryLineChart,
        DepositSummaryBarChart,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        monthlyData: {
            type: Array,
            default: () => [],
        },
        year: {
            type: Number,
            default: 0,
        },
        date: {
            type: String,
            default: '---',
        },
        taiwanDepositTotal: {
            type: Number,
            default: 0,
        },
        foreignDepositTotal: {
            type: Number,
            default: 0,
        },
        taiwanLoanTotal: {
            type: Number,
            default: 0,
        },
        foreignLoanTotal: {
            type: Number,
            default: 0,
        },
        cashTotal: {
            type: Number,
            default: 0,
        },
        toBeCredited: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isShowLineChart: true,
        };
    },
    computed: {
        summaryTotal() {
            return this.taiwanDepositTotal + this.foreignDepositTotal + this.cashTotal + this.loanTotal;
        },
        taiwanDepositPercent() {
            if (this.isLoading) return null;
            return this.getPercent(this.taiwanDepositTotal, this.summaryTotal - this.loanTotal);
        },
        foreignDepositPercent() {
            if (this.isLoading) return null;
            return this.getPercent(this.foreignDepositTotal, this.summaryTotal - this.loanTotal);
        },
        cashPercent() {
            if (this.isLoading) return null;
            return this.getPercent(this.cashTotal, this.summaryTotal - this.loanTotal);
        },
        loanTotal() {
            return this.taiwanLoanTotal + this.foreignLoanTotal;
        },
    },
    methods: {
        isCurrentYear() {
            return this.year === new Date().getFullYear();
        },
        getPercent(value, total) {
            const p = Math.round((value / total) * 1000) / 10;
            return p || '--';
        },
        updateCharts(isLineChart) {
            const chart = isLineChart ? this.$refs.lineChart : this.$refs.barChart;
            setTimeout(() => {
                chart.updateChartSize();
            }, 1);
        },
    },
};
</script>
<style lang="scss">
.deposit-summary-card {
    .deposit-summary-list-block {
        width: 100%;
        max-width: 400px;
        margin: 0 auto;

        .summary {
            .title {
                font-size: 10pt;
                font-weight: bold;
            }
            .number {
                margin-top: 4px;
                font-size: 18pt;

                .cny {
                    font-size: 9pt;
                    margin-left: 5px;
                }
            }
        }
    }

    .deposit-summary-list {
        margin: 25px 0 0 0;
        width: 100%;
        font-size: 10pt;

        .dot {
            width: 25px;

            .circle {
                display: inline-block;
                width: 10px;
                height: 10px;
                background-color: red;
                vertical-align: middle;
                border-radius: 10px;
            }
        }

        .name {
            text-align: left;
        }

        .amt {
            text-align: right;
            padding: 0 10px 0 0;
        }

        .cny {
            text-align: left;
        }

        th.amt {
            padding: 5px 10px 10px 5px;
        }

        .per {
            text-align: right;
        }
    }
}
</style>
